import { useApiClient } from "../../../hooks/useApiClient";
import useSWRImmutable from "swr/immutable";
import {
  type ICommercialMonitoringAmountResponse,
  type ICommercialMonitoringAmountObject,
} from "../types";

interface IResponse {
  data: ICommercialMonitoringAmountObject | null;
  isLoading: boolean;
}

export const useCommercialMonitoringAmount = (): IResponse => {
  const { apiClient } = useApiClient();

  // swrに引き渡すfetcher
  const fetcher = async (
    url: string
  ): Promise<ICommercialMonitoringAmountResponse> => {
    const { data } = await apiClient.get<ICommercialMonitoringAmountResponse>(
      url
    );
    return data;
  };

  const toObjectList = (
    data: ICommercialMonitoringAmountResponse | undefined
  ): ICommercialMonitoringAmountObject | null => {
    if (data === undefined) {
      return null;
    }
    return data;
  };

  const { data: amount, isLoading } = useSWRImmutable(
    "/commercial-monitoring/amount",
    fetcher
  );

  return { data: toObjectList(amount), isLoading };
};
